import { variables } from '@domain-group/fe-brary';
var paginatorLargeBreakpoint = variables.global.tabletMinWidth;
export { paginatorLargeBreakpoint };